import { Component, OnInit, Compiler, Renderer2 } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { CommonService } from '../service/commons-service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ErrorComponent } from '../confirm/error.component';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';
import * as $ from 'jquery'

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
    one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
        ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
        ? false : one.day > two.day : one.month > two.month : one.year > two.year;

@Component({
    templateUrl: 'dashboard.component.html',
    styleUrls: ['dashboard.component.css']

})
export class DashboardComponent implements OnInit {
     users: any = {};
     loading = false;
     loginImageURL: any = null;
     loginUserName: any = "";
     hoveredDate: NgbDateStruct;
     fromDate: NgbDateStruct;
     toDate: NgbDateStruct;
     fetchData: any[] = [];
     userRoll: number = 0;
     userType: any;
     towerInfoList: any[] = [];
    functionList: any = [];
     towerId: any;
     selectedTowerId: any = null;
    
     selectedIbuId: any = null;
    
     selectedFunctionId: any = null;
     allPositions: any = [];
     behData: any;
     funData: any;
    ibuList: any = [];
    positionList: any = [];
    behDataByTower: any = [];
    funDataByTower: any = [];
    towersOfSelectedIbu: any = [];
    towerIdsBySelectedIbu: any = [];
    isBehData: any = true;
    isFunData: any = true;
    userIbuIds: any = [];
    behDataByTowerForStatus: any = [];
    funDataByTowerForStatus: any = [];
    ibuName: any = '';
    selectedTowerName: any = '';
    userAllNotesList: any = [];
    loadingTower: boolean = false;
    constructor(calendar: NgbCalendar, private router: Router, private appConfig: AppConfig,
        private excelService: ExcelService,
        private commonService: CommonService,
        private _compiler: Compiler,
        private render: Renderer2,
    ) {
        this._compiler.clearCache();
        this.users = JSON.parse(localStorage.getItem('user'));
        if (!this.users || !this.users.userData) {
            this.commonService.logout();
            return;
        }
        if (this.users && this.users.userData) {
            if (this.users.userData.userFullName) {
                this.loginUserName = this.users.userData.userFullName;
            } else {
                this.loginUserName = this.users.userData.userName;
            }
            this.userRoll = this.users.userData.userRoll;
            // For set default IBU selected on dashboard
            this.userIbuIds = (this.users.userData.ibuId) ? this.users.userData.ibuId.split(',') : [];
            if (this.userIbuIds) {
                this.selectedIbuId = this.userIbuIds[0];
            }
            console.log(this.userIbuIds);
            switch (this.users.userData.userRoll) {
                case "1": this.userType = "Super Admin"; break;
                case "2": this.userType = "Admin"; break;
                case "3": this.userType = "HR"; break;
                case "4": this.userType = "Manager"; break;
                case "5": this.userType = "Employee"; break;
            }
        }
        this.fromDate = calendar.getToday();
        this.toDate = calendar.getNext(calendar.getToday(), 'd', 0);
        this.loginImageURL = this.appConfig.getDefaultImgURL();
        this.getIbuList();

    }

    isHovered = date => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
    isInside = date => after(date, this.fromDate) && before(date, this.toDate);
    isFrom = date => equals(date, this.fromDate);
    isTo = date => equals(date, this.toDate);

    ngOnInit() {
        this.selectedTowerId = JSON.parse(localStorage.user).userData.towerId;
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.render.removeClass(document.body, 'modal-open');
                $(document.body).removeClass('modal-open');
                $('.modal-backdrop').remove();
            });
            
        setTimeout(() => {
            if (this.towerIdsBySelectedIbu.length) {
                this.getBehDataForReport();
                this.getFunDataForReport();
                this.fetchPositions();
                this.getFunDataByTowerIdForReportForStatus();
                this.getBehDataByTowerIdForReportForStatus();
                this.getBehDataByTowerIdForReport();
                this.getFunDataByTowerIdForReport();
                this.fetchuserData();
                this.getAllUserNotes();
                if(this.ibuList.length) {
                    for (let i = 0; i < this.ibuList.length; i++) {
                        console.log('loop Test', this.ibuList[i].ibuId, this.selectedIbuId);
                        if (this.ibuList[i].ibuId == this.selectedIbuId)
                            this.ibuName = this.ibuList[i].ibuName;
                            localStorage.setItem("ibuName", this.ibuName);
                    }
                    let functionName = this.getFunctionNameById();
                    localStorage.setItem("functionName", functionName);
                    // For Set tower Name
                    for(let i = 0; i < this.towersOfSelectedIbu.length; i++) {
                        if(this.selectedTowerId && this.selectedTowerId == this.towersOfSelectedIbu[i].towerId) {
                            this.selectedTowerName = this.towersOfSelectedIbu[i].towerName;
                            localStorage.setItem('selectedTowerName', this.towersOfSelectedIbu[i].towerName);
                        }
                    }
                }
            }

        }, 800);
    }
    /**
     * Set Ibu Id.
     */
    private setIbuId() {
        this.ngOnInit();
        this.isBehData = true;
        this.isFunData = true;
        this.selectedFunctionId = null;
        this.getFunctionList();
        this.selectedTowerId = null;
        this.towerInfoList = [];
    }
    /**
     * Change function dropdown
     */
    onChangeFunction() {
        this.selectedTowerId = null;
        let tempArr = [];
        let count = 1;
        for (let i = 0; i < this.towersOfSelectedIbu.length; i++) {
            if (this.selectedFunctionId == this.towersOfSelectedIbu[i].functionId ) {
                tempArr.push(this.towersOfSelectedIbu[i]);
            }
            if (count == this.towersOfSelectedIbu.length) {
                this.towerInfoList = tempArr;
            }
            count++;
        }
        let functionName = this.getFunctionNameById();
        localStorage.setItem("functionName", functionName);
    }
    /**
     * Set tower Id in localstorage
     */
    setTowerIdInLocalStorage() {
        var userJson = JSON.parse(localStorage.user);
        userJson.userData.towerId = Number(this.selectedTowerId);
        localStorage.setItem("user", JSON.stringify(userJson));
        for(let i = 0; i < this.towersOfSelectedIbu.length; i++) {
            if(this.selectedTowerId == this.towersOfSelectedIbu[i].towerId) {
                this.selectedTowerName = this.towersOfSelectedIbu[i].towerName;
                localStorage.setItem('selectedTowerName', this.towersOfSelectedIbu[i].towerName);
            }
        }
    }
    /**
     * Set Tower Id
     */
    private setTowerId() {
        this.setTowerIdInLocalStorage();
        for(let i = 0; i < this.towersOfSelectedIbu.length; i++) {
            if(this.selectedTowerId == this.towersOfSelectedIbu[i].towerId) {
                this.selectedTowerName = this.towersOfSelectedIbu[i].towerName;
                localStorage.setItem('selectedTowerName', this.towersOfSelectedIbu[i].towerName);
            }
        }
        // Get user of selected towers for excel export
        this.fetchuserData();
        // Get competency by tower Id.
        this.getFunDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReportForStatus();
        this.getBehDataByTowerIdForReport();
        this.getFunDataByTowerIdForReport();

    }
    /**
     * Get list of IBU
     */
    getIbuList() {
        this.ibuList = [];
        this.commonService.getAllIBUInfo().subscribe(data => {
            for(let i=0; i < data.length; i++) {
                const index = this.userIbuIds.findIndex(x => Number(x) == data[i].ibuId);
                if(index != -1) {
                    this.ibuList.push(data[i]);
                }
                if(i == data.length - 1) {
                    // this.selectedIbuId = this.ibuList[0].ibuId;
                    this.getFunctionList();
                }
            }
        },
            error => {
                console.log('Ibu list not found');
            });
    }

    //Get tower info by towerId
    private getTowerInfoByIbuId() {
        this.loadingTower = true;
        this.towerInfoList = [];
        var towerTempList = [];
        this.towerIdsBySelectedIbu = [];
        // Tower list by IBU only
        this.commonService.getTowersListByIbuId(this.selectedIbuId, this.selectedFunctionId).pipe(first()).subscribe(
            data => {
                this.towerInfoList = data;
                this.towersOfSelectedIbu = data;
                // Push tower Ids in array
                for (let i = 0; i < this.towersOfSelectedIbu.length; i++) {
                    this.towerIdsBySelectedIbu.push(this.towersOfSelectedIbu[i].towerId);
                }
                if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4 ||
                    JSON.parse(localStorage.getItem('user')).userData.userRoll == 6) {
                    for (let i = 0; i < this.towerInfoList.length; i++) {
                        var towerIdArray = JSON.parse(localStorage.getItem('user')).userData.towerIdArray;
                        if (towerIdArray.indexOf(this.towerInfoList[i].towerId.toString()) == -1)
                            continue;
                        towerTempList.push(this.towerInfoList[i]);
                    }
                    this.towerInfoList = towerTempList;
                }
                if (this.towerInfoList.length) {
                    this.selectedTowerId = this.towerInfoList[0].towerId;
                    this.setTowerIdInLocalStorage();
                }
                this.loadingTower = false;
            },
            error => {
                this.loadingTower = false;
                
            }
        )
    }


    // reset on date selection
    private onDateSelection(date: NgbDateStruct) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
            this.toDate = date;
        } else {
            this.toDate = null;
            this.fromDate = date;
        }
    }

    // frorward to next section 
    public gotoNextPage(e, routeURL) {
        this.router.navigate([routeURL]);
    }

    

    // logout and forward to next section
    private logout() {
        this.commonService.logout();
    }

    /**
* Get user Notes
*/
    getAllUserNotes() {
        this.commonService.getAllUserNotes().subscribe(data => {
            this.loading = false;
            if (data) {
                this.userAllNotesList = data;
                

            }
        }, error => {
            console.log('Error', error);
            this.loading = false;
        });
    }
    /**
     * Return Users notes
     */
    returnUserNotes(userId) {
        for (let i = 0; i < this.userAllNotesList.length; i++) {
            if (userId == this.userAllNotesList[i].userId) {
                return this.userAllNotesList[i].userNotes;
            }
        }

    }

     excelReport() {
        let excelExportData = [];
        // let headers = ["S.No.", "Employee Code", "Employee Name", "Email id", "IBU", "Function", "Tower", "Current Role", "Target Role", "Final Rating Status", "Self Rating Status (Behavioral)", "Self Rating Status (Functional)", "Manager Rating Status (Behavioral)", "Manager Rating Status (Functional)", "Rating Score Behavioral", "Rating Score Functional", "Aggregate Score", "Role Change Status"];
        let headers = ["S.No.", "Employee Code", "Employee Name", "Approve Date", "Email id", "IBU", "Function", "Tower", "Employee Status", "Batch Number", "Journey Completion Date", "TR Status", "Current Role", "Target Role", 
        "Supervisor (1st Level)", "Supervisor (1st Level) Email", "Supervisor (2nd Level)", "Supervisor (2nd Level) Email", "Beh. Comp Submitted Date","Fun. Comp Submitted Date","Self Rating Status (Behavioral)",
         "Self Rating Status (Functional)", "Manager Rating Status (Behavioral)", "Manager Rating Status (Functional)", "Final Rating Status", "Rating Score Behavioral", 
        "Rating Score Functional", "Average Score", "Role Change Status", "Notes"];
        // for (let i of this.fetchData)
        console.log('Report this.fetchData', this.fetchData);
        console.log('Report this.behDataByTower', this.behDataByTower);
        console.log('Report this.funDataByTower', this.funDataByTower);

        for (let i = 0; i < this.fetchData.length; i++) {
            let strData = '' + this.fetchData[i].email;
            if (strData.match(/_old$/)) continue;
            let data = {};
            data[headers[0]] = i + 1;
            data[headers[1]] = this.fetchData[i].empCode;
            data[headers[2]] = this.fetchData[i].userName;
            let approvDate = new Date( this.fetchData[i].approvedAt);
            data[headers[3]] =  (this.fetchData[i].approvedAt) ? approvDate.getDate()+ "-" + Number(approvDate.getMonth() + 1)  + "-" +  approvDate.getFullYear() : '' ;
            data[headers[4]] = this.fetchData[i].email;
            data[headers[5]] = this.getIbuNameById();
            data[headers[6]] = this.fetchData[i].functionName;
            data[headers[7]] = this.fetchData[i].towerName;
            if(this.fetchData[i].empStatus == 0) {
                data[headers[8]] = "Deactive";
            } else if(this.fetchData[i].empStatus == 2) {
                data[headers[8]] = "Resigned";
            } else {
                data[headers[8]] = "Active";
            }
            data[headers[9]] = this.fetchData[i].batchNo;
            data[headers[10]] = this.fetchData[i].journeyCompletionDate;
            data[headers[11]] = this.commonService.getUserStatus(this.fetchData[i].isApproved)
            
            data[headers[12]] = this.fetchData[i].positionName;
            //   data[headers[5]] = this.allPositions[this.fetchData[i].userId];
            data[headers[13]] = this.getPositionName(this.fetchData[i].nextPosition);
            data[headers[14]] = this.fetchData[i].resourceManager;
            data[headers[15]] = this.fetchData[i].resourceManagerEmail;
            data[headers[16]] = this.fetchData[i].SLS;
            data[headers[17]] = this.fetchData[i].SLSE;
            data[headers[18]] = this.getManagerBehCompLastDate(this.fetchData[i].userId);
            data[headers[19]] = this.getManagerFunCompLastDate(this.fetchData[i].userId);

            
            // var status = "Pending with Self";
            var compositeValues = this.getCompositeValue(this.fetchData[i].userId);
            

            data[headers[20]]  = (this.checkSelfBehCompExist(this.fetchData[i].userId) > 0) ? 'Submitted' : 'Pending';
            data[headers[21]] = (this.checkSelfFunCompExist(this.fetchData[i].userId) > 0 ) ? 'Submitted' : 'Pending';
            data[headers[22]] = (this.checkManagerBehCompExist(this.fetchData[i].userId) > 0) ? 'Submitted' : 'Pending';
            data[headers[23]] = (this.checkManagerFunCompExist(this.fetchData[i].userId) > 0) ? 'Submitted' : 'Pending';
            
            if ((data[headers[20]] == 'Submitted' && data[headers[21]] == 'Submitted') && ((data[headers[22]] == 'Submitted' && data[headers[23]] == 'Submitted'))) {
                data[headers[24]] = 'Completed'
            }
            if (data[headers[22]] == 'Pending' || data[headers[23]] == 'Pending') {
                data[headers[24]] = 'Pending With Manager'
            }
            if (data[headers[20]] == 'Pending' || data[headers[21]] == 'Pending') {
                data[headers[24]] = 'Pending With Self'
            }
            
            data[headers[25]] = isNaN(compositeValues.beh) ? "" : compositeValues.beh;
            data[headers[26]] = isNaN(compositeValues.fun) ? "" : compositeValues.fun;
            data[headers[27]] = isNaN(compositeValues.full) ? "" : compositeValues.full;
            if (data[headers[27]] >= 80) { data[headers[28]] = "Ready Now"; } 
            if (data[headers[27]] >= 60 && data[headers[27]] < 80) {  data[headers[28]] = "Ready Soon"; } 
            if (data[headers[27]] >= 30 && data[headers[27]] < 60) { data[headers[28]] = "Ready Future"; }
            if (data[headers[27]] < 30) { data[headers[28]] = " "; }
            data[headers[29]] = this.returnUserNotes(this.fetchData[i].userId)
            excelExportData.push(data);
        }
        console.log('excelExportDataexcelExportData', excelExportData);
        this.excelService.generateExcel(headers, excelExportData, 'Dashboard_Data');
    }

    

    // /fetch user information data
    private fetchuserData() {
        this.loading = true;
        let towerId = JSON.parse(localStorage.getItem('user')).userData.towerId;
        let userid = JSON.parse(localStorage.getItem('user')).userData.userEmail;
        var userEmail = "";
        if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
            userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;
        
        let postData = { towerId: this.towerIdsBySelectedIbu };
        console.log('this.towerIdsBySelectedIbu', this.towerIdsBySelectedIbu);
        this.commonService.getUsersForReportByTowerIdsArr(postData).pipe(first()).subscribe(
            data => {
                console.log('DatatatatAA', data);
                let userIds = [];
                for (let i = 0; data && (i < data.length); i++) {
                    if (data[i].userId) {
                        userIds.push({ userId: data[i].userId, towerId: data[i].towerId });
                    }
                }
                if (userIds.length > 0) {
                    // this.fetchUserSkillsData(userIds, data);
                    this.fetchData = data;
                    this.getAllNextPositions2(userIds);
                }
                else {
                    this.loading = false;
                    localStorage.setItem('errorMsg', 'Users Not Found');
                    this.commonService.showerror();
                }
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    // /fetch user information data
    private getFunDataForReport() {
        this.loading = true;

        var userEmail = "";
        
        this.commonService.getFunDataForReport().pipe(first()).subscribe(
            data => {

                this.funData = data;
                this.loading = false;
               
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    private getCompositeValue(userId) {
        var compositeBehSum = 0, compositeFunSum = 0;
        var managerPresentBeh = false, managerPresentFun = false, selfPresentBeh = false, selfPresentFun = false;
        var countBeh = 0, countFun = 0;
       
        for (var i = 0; i < this.behDataByTower.length; i++) {
            if (this.behDataByTower[i].ratedByRole == 4 && this.behDataByTower[i].userId == userId) {
                managerPresentBeh = true; 
                selfPresentBeh = true;
            }

            

            if (this.behDataByTower[i].ratedByRole !== 4 || this.behDataByTower[i].userId != userId) continue;

            var thisSkillsPercentage = (this.behDataByTower[i].skillScore * 100) / this.behDataByTower[i].targetScore;
            compositeBehSum += (thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage);
            
            countBeh++;
        }

        for (var j = 0; j < this.funDataByTower.length; j++) {
            if (this.funDataByTower[j].ratedByRole == 4 && this.funDataByTower[j].userId == userId) {
                managerPresentFun = true; 
                selfPresentFun = true;
            }

            if (this.funDataByTower[j].ratedByRole !== 4 || this.funDataByTower[j].userId != userId) continue;

            var thisSkillsPercentage = (this.funDataByTower[j].skillScore * 100) / this.funDataByTower[j].targetScore;

            compositeFunSum += (thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage);
            countFun++;
        }
       
        return {
            full: Math.floor(((compositeBehSum / countBeh) * 0.3 + (compositeFunSum / countFun) * 0.7)),
            beh: Math.floor(compositeBehSum / countBeh),
            fun: Math.floor(compositeFunSum / countFun),
            managerPresentFun,
            managerPresentBeh,
            selfPresentFun,
            selfPresentBeh
        };

    }


    // /fetch user information data
    private getBehDataForReport() {
        this.loading = true;
        var userEmail = "";
        this.commonService.getBehDataForReport().pipe(first()).subscribe(
            data => {
                this.behData = data;
                this.loading = false;
                // localStorage.setItem('errorMsg', 'Users Not Found');
                // this.commonService.showerror();
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    //fetch user skills data
    private getAllNextPositions(userIds, towerId) {
        this.commonService.getAllNextPositions(userIds, towerId).pipe(first()).subscribe(
            data => {
                this.allPositions = data;
                var that = this;
                setTimeout(function () {
                    that.loading = false;
                }, 1000);
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    //fetch user skills data
    private getAllNextPositions2(userIds) {
        this.commonService.getAllNextPositions2(userIds).pipe(first()).subscribe(
            data => {
                this.allPositions = data;
                var that = this;
                setTimeout(function () {
                    that.loading = false;
                }, 1000);
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    redirectToUrl(url) {
        if (url) {
            window.open(url, "_blank");
        }
    }
    /**
     * Get the function list
     */
    getFunctionList() {
        this.loading = true;
        this.functionList = [];
        this.commonService.getFunctionListByIbuId(this.selectedIbuId).subscribe(data => {
            this.loading = false;
            this.functionList = data;
            console.log('this.functionListthis.functionList', this.functionList);
            if (this.functionList.length) {
                this.selectedFunctionId = this.functionList[0].functionId;
                let functionName = this.getFunctionNameById();
                localStorage.setItem("functionName", functionName);
                this.getTowerInfoByIbuId();
            }
        },
        error => {
            this.loading = false;
            console.log('Error in function list');
        });
    }
    // /fetch user information data
    private fetchPositions() {
        let towerId = null;
        this.commonService.getAllPositionInfo(towerId).pipe(first()).subscribe(
            data => {
                this.positionList = data;
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    private getPositionName(positionId) {
        for (let i = 0; i < this.positionList.length; i++) {
            if (this.positionList[i].positionId == positionId)
                return this.positionList[i].positionName;
        }
    }
    // Get Tower name
    towerNameById(towerId) {
        for (let i = 0; i < this.towerInfoList.length; i++) {
            if (this.towerInfoList[i].towerId == towerId)
                return this.towerInfoList[i].towerName;
        }
    }
    // Get Function name
    getFunctionNameById() {
        for (let i = 0; i < this.functionList.length; i++) {
            if (this.functionList[i].functionId == this.selectedFunctionId) {
                return this.functionList[i].functionName;
            }
              
        }
    }
    // Get IBU name
    getIbuNameById() {
        for (let i = 0; i < this.ibuList.length; i++) {
            if (this.ibuList[i].ibuId == this.selectedIbuId)
                this.ibuName = this.ibuList[i].ibuName;
                return this.ibuList[i].ibuName;
        }
    }
    // Get Beh comp data
    private getBehDataByTowerIdForReport() {
        this.loading = true;
        let postData = { towerId: this.towerIdsBySelectedIbu};
        this.commonService.getBehDataByTowerIdReport(postData).pipe(first()).subscribe(
            data => {
                this.behDataByTower = data;
                console.log('this.behDataByTower', this.behDataByTower);
                this.loading = false;
                if (this.behDataByTower.length) {
                    this.isBehData = false;
                }
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    // Get Beh comp data
    private getBehDataByTowerIdForReportForStatus() {
        this.loading = true;
        let postData = { towerId: this.towerIdsBySelectedIbu};
        this.commonService.getBehDataByTowerIdReportForStatus(postData).pipe(first()).subscribe(
            data => {
                this.behDataByTowerForStatus = data;
                console.log('this.behDataByTower', this.behDataByTowerForStatus);
                this.loading = false;
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    // Get Beh comp data
    private getFunDataByTowerIdForReport() {
        this.loading = true;
        let postData = { towerId: this.towerIdsBySelectedIbu };
        this.commonService.getFunDataByTowerIdReport(postData).pipe(first()).subscribe(
            data => {
                this.funDataByTower = data;
                console.log('this.funDataByTower', this.funDataByTower);
                this.loading = false;
                if (this.funDataByTower.length) {
                    this.isFunData = false;
                }
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
     // Get Beh comp data
     private getFunDataByTowerIdForReportForStatus() {
        this.loading = true;
        let postData = { towerId: this.towerIdsBySelectedIbu };
        this.commonService.getFunDataByTowerIdReportForStatus(postData).pipe(first()).subscribe(
            data => {
                this.funDataByTowerForStatus = data;
                console.log('this.funDataByTowerForStatus', this.funDataByTowerForStatus);
                this.loading = false;
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    // Check users have self beh. competency submitted or not.
    checkSelfBehCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.behDataByTowerForStatus.length; i++) {
            if (this.behDataByTowerForStatus[i].userId == $userId && this.behDataByTowerForStatus[i].ratedByRole == 5) {
                count++;
            }
        }
        return count;
    }
    // Check users have self beh. competency submitted or not.
    checkManagerBehCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.behDataByTowerForStatus.length; i++) {
            if (this.behDataByTowerForStatus[i].userId == $userId && this.behDataByTowerForStatus[i].ratedByRole == 4) {
                count++;
            }
        }
        return count;
    }
    // Check users have self beh. competency submitted or not.
    getManagerBehCompLastDate($userId) {
        let  lastDate = '';
        for (let i = 0; i < this.behDataByTower.length; i++) {
            if (this.behDataByTower[i].userId == $userId && this.behDataByTower[i].ratedByRole == 4 && (lastDate == '' || new Date(lastDate )< new Date(this.behDataByTower[i].createDate))) {

                lastDate = this.behDataByTower[i].createDate;
            }
        }
        if(lastDate) {
            let date = new Date(lastDate);
            return  date.getDate()+ "-" + Number(date.getMonth() + 1)  + "-" +  date.getFullYear();
        } else {
            return lastDate;
        }
    }
     // Check users have self beh. competency submitted or not.
     getManagerFunCompLastDate($userId) {
        let  lastDate = '';
        for (let i = 0; i < this.funDataByTower.length; i++) {
            if (this.funDataByTower[i].userId == $userId && this.funDataByTower[i].ratedByRole == 4 && (lastDate == '' || new Date(lastDate )< new Date(this.funDataByTower[i].createDate))) {

                lastDate = this.funDataByTower[i].createDate;
            }
        }
        if(lastDate) {
            let date = new Date(lastDate);
            return date.getDate()+ "-" + Number(date.getMonth() + 1)  + "-" +  date.getFullYear();
        } else {
            return lastDate;
        }
    }
    // Check users have self beh. competency submitted or not.
    checkSelfFunCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.funDataByTowerForStatus.length; i++) {
            if (this.funDataByTowerForStatus[i].userId == $userId && this.funDataByTowerForStatus[i].ratedByRole == 5) {
                count++;
            }
        }
        return count;
    }
    // Check users have self beh. competency submitted or not.
    checkManagerFunCompExist($userId) {
        let count = 0;
        for (let i = 0; i < this.funDataByTowerForStatus.length; i++) {
            if (this.funDataByTowerForStatus[i].userId == $userId && this.funDataByTowerForStatus[i].ratedByRole == 4) {
                count++;
            }
        }
        return count;
    }

}